<template>
	<div id="hres80x-history-heal-illness2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#historyHealIllness2">
      <h3 class="box-title color-skin">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{labels['HRES80XP2']['10']}}
      </h3>
    </div>
    <div id="historyHealIllness2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
        	<!-- header -->
          <div class="hisheal-header">{{labels['HRES80XP2']['20']}}</div>
          <div class="table-overflow">
            <table class="table-1">
              <tr>
                <td class="bg-color-skin text-center" style="width: 10%;">{{labels['HRES80XP2']['30']}}</td>
                <td class="bg-color-skin" style="width: 80%;">{{labels['HRES80XP2']['40']}}</td>
                <td class="bg-color-skin text-center" style="width: 10%;">{{labels['HRES80XP2']['50']}}</td>
              </tr>
              <tr v-for="(dataRow,index) in dataHisHealDetail" :key="index">
                <td class="text-center">{{dataRow.numseq}}</td>
                <td>{{dataRow.dessick}}</td>
                <td class="text-center">{{dataRow.dteyear}}</td>
              </tr>
            </table>
          </div>
          <div v-if="dataHisHealDetail.length === 0" class="text-center hisheal-nodata">
            No data found.
          </div>
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres80x-history-heal-illness2',
  props: [
    'labels',
    'dataHisHealDetail'
  ]
}
</script>



// WEBPACK FOOTER //
// historyHealIllness2.vue?a24a676c